import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { IconButton } from '@awaze/design-system.components.button';
import { Stack } from '@awaze/design-system.components.stack';
import { pxToRems } from '@awaze/design-system.utils.react';
import { ChevronLeft, ChevronRight } from './icons';
import { getMonthFromNow } from './calendar.utils';
const StyledCalendarNavigation = styled.div `
  height: ${pxToRems(8)};
  position: relative;
`;
export const CalendarNavigation = ({ currentMonth, setCurrentMonth, minDate, maxDate, onMonthNext, onMonthPrev, translations: { prevButtonTitle, nextButtonTitle }, }) => {
    const navigatePrev = () => {
        const previousMonth = getMonthFromNow(currentMonth, -1);
        setCurrentMonth(previousMonth);
        onMonthPrev && onMonthPrev();
    };
    const navigateNext = () => {
        const nextMonth = getMonthFromNow(currentMonth, 1);
        setCurrentMonth(nextMonth);
        onMonthNext && onMonthNext();
    };
    const activeMonth = currentMonth.getMonth();
    const activeYear = currentMonth.getFullYear();
    const minDateMonth = minDate && minDate.getMonth();
    const minDateYear = minDate && minDate.getFullYear();
    const maxDateMonth = maxDate && maxDate.getMonth();
    const maxDateYear = maxDate && maxDate.getFullYear();
    const previousDisabled = activeMonth === minDateMonth && activeYear === minDateYear;
    const nextDisabled = activeMonth === maxDateMonth && activeYear === maxDateYear;
    return (_jsx(StyledCalendarNavigation, { children: _jsxs(Stack, { isHorizontal: true, justify: "space-between", children: [_jsx(IconButton, { isDisabled: previousDisabled, variant: "ghost", colourScheme: "brand-primary", disabled: previousDisabled, onClick: navigatePrev, title: prevButtonTitle, icon: _jsx(ChevronLeft, {}), size: "small", type: "button" }), _jsx(IconButton, { isDisabled: nextDisabled, variant: "ghost", colourScheme: "brand-primary", disabled: nextDisabled, onClick: navigateNext, title: nextButtonTitle, icon: _jsx(ChevronRight, {}), size: "small", type: "button" })] }) }));
};
//# sourceMappingURL=calendar-navigation.js.map